// extracted by mini-css-extract-plugin
export default {"MessagesPopup":"MessagesPopup_MessagesPopup__hyM6w"};